import React, {Component} from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import flow from 'lodash/flow'
import Fontawesome from 'react-fontawesome'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { findDOMNode } from 'react-dom';

const style = {
   
};

const cardSource = {
    isDragging(props, monitor) {
        return monitor.getItem().id === props.id
    },

    beginDrag(props) {
        return {
            id: props.id,
            index: props.index,
        }
    },
};
  
const cardTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index
        const hoverIndex = props.index
  
        if (dragIndex === hoverIndex) {
            return;
        }
  
        const hoverBoundingRect = (findDOMNode(
            component,
        )).getBoundingClientRect();
  
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
  
        const clientOffset = monitor.getClientOffset();
  
        const hoverClientY = (clientOffset).y - hoverBoundingRect.top;
  
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }
  
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }
  
        props.moveCard(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },

    drop(props, monitor, component) {
        if (monitor.didDrop()) {
            return
        }
        
        if (props.onSortSave!==undefined)
            props.onSortSave()
    }    
}

class CategoryItem extends Component {

    constructor(props) {
        super(props)
        this.state = {isShowDrag:-1}
    }
        
    onMouseOver(index) {
        this.setState({isShowDrag:index})
    }

    onMouseOut() {
        this.setState({isShowDrag:-1})
    }

    onCategorySelect(item) {
        if (this.props.onCategorySelect!==undefined)
            this.props.onCategorySelect(item)
    }

    onCategoryEditClick(item) {
      if (this.props.onCategoryEditClick!==undefined)
        this.props.onCategoryEditClick(item)
    }

    render() {
        const {connectDragSource,connectDropTarget,item,index,isDragging,category_active} = this.props
        const opacity = isDragging ? 0 : 1
        let {isShowDrag} = this.state
        let hover = (
            <OverlayTrigger
                key={'right'}
                placement={'right'}
                overlay={
                    <Tooltip id={'tooltip-right'}>
                        Hold & darg to sort the FAQs
                    </Tooltip>
                }
                >
                <div style={{display:isShowDrag===index?'':'none'}} className='card-tool'><Fontawesome name='ellipsis-v' /></div>
            </OverlayTrigger>
        )
        return (
            connectDragSource &&
            connectDropTarget &&
            connectDragSource(
                connectDropTarget(
                    <div onMouseOver={this.onMouseOver.bind(this,index)} onMouseOut={this.onMouseOut.bind(this)} onClick={this.onCategorySelect.bind(this,item)} className={'nav-category'+(category_active===item.cat_id?' active':'')} key={index} style={{ ...style, opacity }}>
                        <div className='category-menu'>
                            {hover}
                            <div className='category-menu-flex'>
                                <div className='category-menu-icon'>
                                    <Fontawesome name='file-text' /> 
                                </div>
                                <div className='category-menu-text'>
                                    <h4 className='mg-0'>{item.name}</h4>
                                    <span className={'label '+(item.is_hidden==='0'?'label-success':'label-default')}><small><Fontawesome name={item.is_hidden==='0'?'eye':'eye-slash'} /> {item.is_hidden==='0'?'Active':'Hidden'}</small></span>
                                </div>
                            </div>
                            <div className='float-right'>
                                <small onClick={this.onCategoryEditClick.bind(this,item)}><Fontawesome name='edit' /> Edit</small>
                            </div>
                        </div>    
                    </div>
                )
            )   
        )
    }
}

export default flow(
    DragSource(
        'card',
        cardSource,
        (connect, monitor) => ({
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging(),
        }),
    ),
    DropTarget('card', cardTarget, (connect) => ({
        connectDropTarget: connect.dropTarget(),
    }))    
)(CategoryItem);



// WEBPACK FOOTER //
// ./src/view/faq/CategoryItem.js